export const updateTrackingLocationDelivery = (data) => ({
  type: "UPDATE_TRACKING_LOCATION_DELIVEERY",
  payload: data,
});
